import axios, { AxiosError, AxiosResponse } from 'axios';
import { handleResponse, handleErrorResponse } from '@/helpers/ApiHelper';
import { CompanyEmails, CompanyModel, ContactModel } from '@/store/models/CompanyModel';
import { FeedbackMsgModel, HelpDeskRequestModel } from '@/store/models/CustomerModel';
import { customer } from '@/store/modules/customer';
import { Brand } from '@/store/models/ItemModel';
import { config } from 'vue/types/umd';
import { SetSnackBar } from '@/helpers/SnackbarHelper';
import { AddressRequestModel } from '@/store/models/RequestModels';
const customerUrl = `${process.env.VUE_APP_ROOT_API}/Customer`;
const customerCommonUrl = `${process.env.VUE_APP_COMMON_API}/Customer`;
const addressCommonUrl = `${process.env.VUE_APP_COMMON_API}/Address`;
const brandUrl = `${process.env.VUE_APP_ROOT_API}/Brand`;

export const CustomerService = {
  AddNewBrand(BrandName: string | ContactModel | Brand): Promise<AxiosResponse> {
    let model;
    if ((BrandName as ContactModel).Brand !== undefined) {
      model = BrandName;
    } else if ((BrandName as Brand).Name !== undefined) {
      model = BrandName;
    } else {
      model = {
        BrandName
      };
    }
    return axios.post(`${brandUrl}/AddNewBrand`, model);
  },
  GetAddress(addressId: string) {
    return axios.get(`${customerUrl}/GetAddress?addressId=${addressId}`);
  },
  GetAllBrandsForCustomer(): Promise<AxiosResponse> {
    return axios.get(`${brandUrl}/GetAllBrandsForCustomer`);
  },
  GetCustomerBrands(customerId: string): Promise<AxiosResponse> {
    return axios.get(`${brandUrl}/GetBrandsForCustomer?customerId=${customerId}`);
  },
  GetShippingAddressesFull(
    shouldIncludeCustomerPickup: boolean = true
  ): Promise<AxiosResponse> {
    return axios.get(
      `${customerUrl}/GetShippingAddresses?shouldIncludeCustomerPickup=${shouldIncludeCustomerPickup}`
    );
  },
  GetShippingAddressesCondensed() {
    return axios.get(`${customerUrl}/GetShippingAddressesCondensed/`);
  },
  GetBillingAddresses(isCondensed: boolean = true) {
    return axios.get(`${customerUrl}/GetBillingAddresses?isCondensed=${isCondensed}`);
  },
  GetBillingAddressesCondensed() {
    return axios.get(`${customerUrl}/GetBillingAddressesCondensed/`);
  },
  GetStates(): Promise<AxiosResponse> {
    return axios.get(`${addressCommonUrl}/GetStates`);
  },
  GetCountries(): Promise<AxiosResponse> {
    return axios.get(`${addressCommonUrl}/GetCountries`);
  },
  GetBrand(brandId: number): Promise<AxiosResponse> {
    return axios.get(`${brandUrl}/GetBrand?brandId=${brandId}`);
  },
  GetBrandLogo(brandId: number): Promise<AxiosResponse> {
    return axios.get(`${brandUrl}/GetBrandLogo?brandId=${brandId}`);
  },
  GetCustomerPaymentProfiles(): Promise<AxiosResponse> {
    return axios.get(`${customerUrl}/GetCustomerPaymentProfiles`);
  },
  GetDefaultCustomerPaymentProfileId(): Promise<AxiosResponse> {
    return axios.get(`${customerUrl}/GetDefaultPaymentProfileId`);
  },
  SaveNewPaymentMethod(model: any): Promise<AxiosResponse> {
    return axios.post(`${customerUrl}/SaveNewPaymentMethod`, model);
  },
  CopyFilesToVirtualDirectory(): Promise<AxiosResponse> {
    return axios.get(`${customerUrl}/CopyFilesToVirtualDirectory`);
  },
  DeletePaymentProfile(paymentProfileId: string): Promise<AxiosResponse> {
    return axios.get(`${customerCommonUrl}/DeletePaymentProfile/${paymentProfileId}`);
  },
  DeleteBrand(brandId: number): Promise<AxiosResponse> {
    return axios.get(`${brandUrl}/DeleteBrand?brandId=${brandId}`);
  },
  UpdateAddressDefault(addressId: string, isBilling: boolean) {
    var model = {
      AddressId: addressId,
      IsBilling: isBilling
    };
    return axios.post(`${customerUrl}/UpdateAddressDefault`, model);
  },
  UpdateBrand(model: Brand) {
    return axios.post(`${brandUrl}/UpdateBrand`, model);
  },
  AddNewBillingAddress(model: any) {
    return axios.post(`${customerCommonUrl}/AddNewBillingAddress`, model);
  },
  AddNewShippingAddress(model: any) {
    return axios.post(`${customerUrl}/AddNewShippingAddress`, model);
  },
  UpdateAddress(model: any) {
    return axios.post(`${customerCommonUrl}/UpdateAddress`, model);
  },
  UpdateCompanyProfileDetail(model: CompanyModel) {
    return axios.post(`${customerUrl}/UpdateCompanyProfileDetail`, model);
  },
  UpdatePaymentMethodDefault(profile: any): Promise<AxiosResponse> {
    return axios.post(`${customerCommonUrl}/UpdatePaymentMethodDefault`, profile);
  },
  RemoveAddress(addressId: string) {
    return axios.get(`${customerUrl}/RemoveAddress/${addressId}`);
  },
  UpdateRollDirection(addressId: string, rollDirectionId: number) {
    return axios.get(
      `${customerUrl}/UpdateRollDirection?addressId=${addressId}&rollDirectionId=${rollDirectionId}`
    );
  },
  UpdateContactName(model: ContactModel) {
    return axios.post(`${customerUrl}/UpdateContactName`, model);
  },
  UpdateContactEmail(model: ContactModel) {
    return axios.post(`${customerUrl}/UpdateContactEmail`, model);
  },
  UpdatePrimaryPhone(model: ContactModel) {
    return axios.post(`${customerUrl}/UpdatePrimaryPhone`, model);
  },
  UpdateCustomerOptionRollDirection(rollDirectionId: number) {
    return axios.get(
      `${customerUrl}/UpdateCustomerOptionRollDirection?rollDirectionId=${rollDirectionId}`
    );
  },
  UpdateCustomerOD(od: number) {
    return axios.get(`${customerUrl}/UpdateCustomerOD?od=${od}`);
  },
  UpdateNotificationEmails(model: CompanyEmails) {
    return axios.post(`${customerUrl}/UpdateNotificationEmails`, model);
  },
  UpdateRetentionAddress(model: AddressRequestModel) {
    return axios.post(`${customerUrl}/UpdateRetentionAddress`, model);
  },
  GetEmailList() {
    return axios.get(`${customerCommonUrl}/GetEmailList`);
  },
  GetCurrentCustomer() {
    return axios.get(`${customerUrl}/GetCurrentCustomer`);
  },
  GetCustomerSummaryMetrics() {
    return axios.get(`${customerUrl}/GetCustomerSummaryMetrics`);
  },
  SendACustomerQuestionEmailToRequestedDepartment(model: HelpDeskRequestModel) {
    return axios.post(
      `${customerUrl}/SendACustomerQuestionEmailToRequestedDepartment`,
      model
    );
  },
  SendBugReport(model: FeedbackMsgModel) {
    return axios.post(`${customerUrl}/SubmitBugReport`, model);
  },
  async UploadBrandLogo(model: FormData): Promise<AxiosResponse<any> | undefined> {
    try {
      const response = await axios.post(`${brandUrl}/UploadBrandLogo`, model);
      return response;
    } catch (err) {
      let error = err as AxiosError;
      if (error.response?.status === 415) {
        throw 'Unsupported File Type';
      }
    }
  },
  GetTransparencyCustomerList: function() {
    return axios.get(`${customerUrl}/GetTransparencyCustomerList`);
  },
  GetCustomerShippingAddressesList(customerId: string) {
    return axios.get(
      `${customerUrl}/GetCustomerShippingAddressesList?customerId=${customerId}`
    );
  },
  UpdateCustomerDefaultCCForTerms(profileId: string) {
    return axios.get(
      `${customerCommonUrl}/UpdateCustomerDefaultCCForTerms?profileId=${profileId}`
    );
  }
};
